import CurveTiles from "./curveTiles"
import Sidebar from "./sidebar"

export default class Weights3 extends Component {
  render() {
    return (
      <Surface gridColumn="screen" alignItems="center" marginY={20}>
        <CurveTiles size={75} />

        <Sidebar />
      </Surface>
    )
  }
}
